import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { AsideDefault } from './components/aside/AsideDefault'
import { Footer } from './components/Footer'

import { HeaderWrapper } from './components/header/HeaderWrapper'
import HeaderMobile from './components/header/HeaderMobile'

import { ScrollTop } from './components/ScrollTop'
import { Content } from './components/Content'
import { PageDataProvider } from './core'
import { useLocation } from 'react-router-dom'
import { DrawerMessenger, ActivityDrawer, InviteUsers, UpgradePlan } from '../partials'
import { MenuComponent } from '../assets/ts/components'
import { DefaultTitle } from './components/header/page-title/DefaultTitle'
import ContentToolbar from './components/header/content-toolbar/ContentToolbar'

const MasterLayout = () => {
	const location = useLocation()
	useEffect(() => {
		setTimeout(() => {
			MenuComponent.reinitialization()
		}, 500)
	}, [])

	useEffect(() => {
		setTimeout(() => {
			MenuComponent.reinitialization()
		}, 500)
	}, [location.key])

	return (
		<PageDataProvider>
			<div className="page d-flex flex-row flex-column-fluid">
				<AsideDefault />
				<div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
					<div className="d-none d-lg-block">
						<HeaderWrapper />
					</div>

					<div className="d-lg-none d-block">
						<HeaderMobile />
					</div>

					<div id="kt_content" className="content d-flex flex-column flex-column-fluid">
						<div className="post d-flex flex-column-fluid" id="kt_post">
							<Content>
								<div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center">
									<DefaultTitle />
									<ContentToolbar />
								</div>
								<Outlet />
							</Content>
						</div>
					</div>
					<Footer />
				</div>
			</div>

			{/* begin:: Drawers */}
			<ActivityDrawer />
			{/* <RightToolbar /> */}
			<DrawerMessenger />
			{/* end:: Drawers */}

			{/* begin:: Modals */}
			<InviteUsers />
			<UpgradePlan />
			{/* end:: Modals */}
			<ScrollTop />
		</PageDataProvider>
	)
}

export { MasterLayout }
